import React, {useContext, useEffect} from 'react';
import {Box, CircularProgress, Typography, useTheme} from "@mui/material";
import ElionLogo from '../../assets/rebranding/Elion_Logo_WordmarkBaseline_RGB_Red.svg';
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {CustomTheme} from "../../config/theme/theme";
import {AuthContext, IAuthContext} from "react-oauth2-code-pkce";
import useAuth from "../../hooks/useAuth";
import { LoginLayout } from './loginLayout';
import useData from '../../hooks/useData';

export const Login = () => {
  const authContext: IAuthContext = useAuth();
  const login: () => void = authContext.login;
  const {t} = useTranslation();
  const {loginInProgress}: IAuthContext = useContext(AuthContext);
  const {clearInstallerToken, clearIsInstaller} = useData();
  const theme: CustomTheme = useTheme();

  useEffect(() => {
    clearIsInstaller();
    clearInstallerToken();
  }, []);

  return (
    <>
      <LoginLayout>
        <Box sx={{
          width: {xs: '90%', sm: '400px'},
          backgroundColor: 'white',
          borderRadius: 4,
          boxShadow: '0 0 2px rgba(0, 0, 0, 0.15)',
          padding: 2
        }}>
          <Box display="flex" justifyContent="center" mb={3}>
            <img src={ElionLogo} width='250px' alt="Elion"/>
          </Box>
          <Typography textAlign="center" mb={3} fontSize={15}>U kunt inloggen met uw login van het Elindus klantenportaal.
Heeft u nog geen login aangevraagd? Dan kunt u dat <a
              href="https://klant.elindus.be/s/vraag-hier-uw-login-aan?language=nl_NL" target="_blank"
              rel="noreferrer" style={{textDecoration: 'underline'}}>hier</a> doen.</Typography>
          <Button variant="contained" fullWidth sx={{mt: 1, mb: 2, height: '40px', textTransform: 'none'}} disabled={loginInProgress}
                  onClick={login}>
            {loginInProgress && <CircularProgress size={18}/>}
            {!loginInProgress && <Typography color={theme.palette.text.secondary} fontWeight={600}>{t('login.login')}</Typography>}
          </Button>
        </Box>
      </LoginLayout>
    </>
  );
};
